/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_BAN_BANKS_ITEM = {
  id: 'banks_entities',
  screenId: 'fin-ban-banks',
  label: 'Bancos',
  description: 'Alta de entidades bancarias (Galicia, Santander, etc.) con CUIT.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Acá registrás cada banco o entidad financiera con la que opera la empresa. Es el paso previo a crear cuentas bancarias: primero el banco, después la cuenta.',
      },
      {
        title: 'Paso 1 — Ver la lista',
        bullets: [
          'Columnas: ID y Descripción.',
          'Tocá una fila para ver el detalle (CUIT, descripción, razón social según ARCA).',
          'No hay edición desde esta pantalla: solo consulta y alta.',
          'Podés exportar la lista.',
        ],
      },
      {
        title: 'Paso 2 — Crear un banco',
        intro: 'El botón + abre «Nuevo banco».',
        fields: [
          {
            label: 'CUIT',
            description:
              '11 dígitos sin guiones. Al completar un CUIT válido, el sistema consulta ARCA automáticamente y trae la razón social.',
          },
          {
            label: 'Descripción',
            description:
              'Nombre que verás en listas (se completa desde ARCA al validar el CUIT; podés editarla antes de guardar).',
          },
        ],
        paragraphs: [
          'No podés crear el banco hasta que ARCA haya respondido correctamente para ese CUIT.',
          'Si ya existe un banco con la misma descripción, el sistema avisa «El banco ya existe».',
          'Tocá «Crear banco» para guardar.',
        ],
      },
      {
        title: 'Detalle de un banco',
        bullets: [
          'ID banco — identificador interno.',
          'CUIT — número fiscal de la entidad.',
          'Descripción — nombre corto en el sistema.',
          'Razón social (ARCA) — nombre oficial devuelto por ARCA al validar el CUIT.',
        ],
      },
    ],
  },
}
